import React from "react";
import { Check } from "lucide-react";

const CheckboxView = ({
  label,
  value = false,
  onChange,
  checkPosition = "left",
  disabled = false,
  size = "md",
  id,
  className = "",
  labelClassName = "",
}) => {
  // Generate a fallback unique ID if not explicitly provided
  const generatedId = React.useId();
  const checkboxId = id || generatedId;

  // Size configurations
  const sizes = {
    sm: {
      box: "w-4 h-4 rounded-xs",
      icon: "w-3 h-3",
      text: "text-xs",
    },
    md: {
      box: "w-5 h-5 rounded-md",
      icon: "w-3.5 h-3.5",
      text: "text-sm",
    },
    lg: {
      box: "w-6 h-6 rounded-md",
      icon: "w-4 h-4",
      text: "text-base",
    },
  };

  const currentSize = sizes[size] || sizes.md;

  const renderCheckbox = () => (
    <div className="relative flex items-center justify-center">
      {/* Hidden real input for accessibility & Formik/HTML form support */}
      <input
        type="checkbox"
        id={checkboxId}
        checked={value}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />

      {/* Modern styled checkbox shell */}
      <div
        className={`flex items-center justify-center border transition-all duration-200 cursor-pointer select-none ${
          currentSize.box
        } ${
          value
            ? "bg-primary border-primary text-white shadow-xs"
            : "bg-white border-gray-300 hover:border-indigo-400 group-hover:border-indigo-400"
        } ${
          disabled
            ? "opacity-50 cursor-not-allowed bg-gray-100 border-gray-200"
            : "peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-500/20 peer-focus-visible:ring-offset-1"
        }`}
      >
        <Check
          className={`${currentSize.icon} stroke-[3] transition-transform duration-150 ${
            value ? "scale-100 opacity-100" : "scale-50 opacity-0"
          }`}
        />
      </div>
    </div>
  );

  return (
    <div
      className={`group flex items-center justify-between gap-3 ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      } ${className}`}
    >
      {checkPosition === "left" && renderCheckbox()}

      {label && (
        <label
          htmlFor={checkboxId}
          className={`font-medium text-gray-700 select-none cursor-pointer transition-colors group-hover:text-gray-900 ${
            currentSize.text
          } ${labelClassName}`}
        >
          {label}
        </label>
      )}

      {checkPosition === "right" && renderCheckbox()}
    </div>
  );
};

export default CheckboxView;
